import React from 'react';

export const CommerceInvoice = React.lazy(() => import('./CommerceInvoice'));
export const DriverCost = React.lazy(() => import('./DriverCost'));
export const CompanionCost = React.lazy(() => import('./CompanionCost'));
